export const name = "SINH";
export const summary = `Computes the hyperbolic sine of \`X\`.`;
export const reference = `
## SINH

Computes the hyperbolic sine of \`X\`.

\`\`\`
SINH(X)
\`\`\`

### Description

Computes the hyperbolic sine of X where X is specified in radians. Generates an error if overflow occurs.

| X | SINH(X) |
| --- | --- |
| \`+inf\` | \`+inf\` |
| \`-inf\` | \`-inf\` |
| \`NaN\` | \`NaN\` |


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/mathematical_functions
`;
